export type ActiveClientState = {
  clientCode: string | null;
};

export const initialActiveClientState: ActiveClientState = {
  clientCode: null,
};
